import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getDeliveryInfoRequest = async () => {
  const response: AxiosResponse = await apiInstance.get(
    "/marketplace/delivery-info"
  );

  return response.data;
};
